import { isEqual } from "lodash";
import { useSelector } from "react-redux";
import { useRequest } from "redux-query-react";
import { getFundsAndCffModels } from "api/admin/src";
const useFundsAndCffModelsSelector = () => useSelector((state) => state.entities.FundsAndCffModels, isEqual);
export const useGetFundsAndCffModels = () => {
    const [queryState, forceRequest] = useRequest(getFundsAndCffModels());
    const fundsAndCffModels = useFundsAndCffModelsSelector();
    return {
        fundsAndCffModels,
        queryState,
        refetch: forceRequest
    };
};
